module.exports = __webpack_public_path__ + "static/img/img6.8ba453b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/simulator/img6.png
// module id = KCwd
// module chunks = 1